<template>
  <svg :class="svgClass" :style="{
    width: size + 'px !important',
    height: size + 'px !important',
    color: color,
    'margin-right': mr + 'rem',
  }" aria-hidden="true">
    <use :xlink:href="`#icon-${name}`" />
  </svg>
</template>
<script>
export default {
  name: "svg-icon",
  props: {
    name: { type: String, required: true }, // svg 图标名称
    className: { type: String, default: "" }, // 指定的类样式
    size: { type: Number, default: 20 }, // 图标尺寸
    color: { type: String, default: "#fff" }, // 图标颜色
    mr: { type: String, default: "20" }, // 图标颜色
  },
  computed: {
    // 计算属性
    svgClass() {
      if (this.className) {
        return "svg-icon " + this.className;
      } else {
        return "svg-icon";
      }
    },
  },
};
</script>
<style lang="less" scoped></style>
<style scoped>
.back {
  fill: black !important;
}

.svg-icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
</style>